import {ProductRating} from 'modules/product-card/components/ProductRating';
import {ProductRatings} from 'modules/product-card/components/ProductRatings';
import {ProductFeatureList} from 'modules/product-card/components/ProductFeatureList';
import {ProductCharacteristicsList} from 'modules/product-card/components/ProductCharacteristicsList';
import {ProductCharacteristicsMoreButton} from 'modules/products/components/ProductCharacteristicsMoreButton';
import {Arrow} from 'components/icons/Arrow';
import style from './style.module.scss';
import {FC} from 'react';

interface IProps {
    isFineAndRareCategory: boolean;
    handleSeeAllInfo: () => void;
}

const ProductInfoBlock: FC<IProps> = ({isFineAndRareCategory, handleSeeAllInfo}) => (
    <div className={style.blockInfo}>
        {!isFineAndRareCategory && <ProductRating />}
        <ProductRatings />
        {!isFineAndRareCategory && <ProductFeatureList />}
        <ProductCharacteristicsList
            moreLink={
                <ProductCharacteristicsMoreButton
                    icon={<Arrow direction={'down'} size={'sm'} />}
                    onClick={handleSeeAllInfo}
                    text={'Смотреть все характеристики'}
                />
            }
        />
    </div>
);

export default ProductInfoBlock;
